export const translations = {
  'it-IT': {
    translation: {
      addUser: 'Aggiungi utente',
      editUser: 'Modifica utente',
      firstName: 'Nome',
      lastName: 'Cognome',
      name: 'Nome',
      role: 'Ruolo',
      status: 'Stato',
      email: 'E-mail',
      phone: 'telefono',
      type: 'Tipo',
      details: 'Dettagli',
      nodes: 'Nodi',
      roles: 'Ruoli',
      cancel: 'Annulla',
      submit: 'invia',
      delete: 'Elimina',
      create: 'Crea',
      deleteNodeError: "Errore durante l'eliminazione del nodo",
      deleteConfirmation: 'Eliminare',
      warning: 'Avvertimento',
      Alert: 'Avviso',
      deleteSure: 'Sì, ne sono sicuro',
      nodesWillBeCreatedAt: 'I nodi saranno creati a',
      searchFor: 'Cerca',
      rolesError: 'Errore durante il recupero dei ruoli',
      userListError: "Errore durante il recupero dell'elenco utenti",
      organisationListError:
        "Errore durante il recupero dell'elenco organizzazione",
      loadingRoles: 'Caricamento ruoli...',
      selectRole: 'Seleziona ruolo',
      validEmail: 'Inserire un indirizzo e-mail valido',
      requiredEmail: 'E-mail richiesta',
      resend: 'Reinvia',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'Utente aggiunto con successo',
      editUserSuccess: 'Utente modificato con successo',
      deleteUserSuccess: 'Utente eliminato con successo',
      deleteModalAlertMessage:
        "Stai per eliminare l'utente {{userName}}. Tutti i permessi per l'utente saranno revocati.",
      deleteProceedMessage: "Vuoi procedere con l'eliminazione?",
      userAlreadyExist: 'Utente già esistente con questo ID e-mail.',
      addUserError: 'Impossibile aggiungere utente. Riprovare.',
      editUserError: "Impossibile modificare l'utente. Riprovare.",
      deleteUserError: "Impossibile eliminare l'utente. Per favore, riprova.",
      nodesError: 'Errore durante il recupero di nodi assegnati',
      childNodesError: 'Errore durante il caricamento di nodi figlio',
      hierarchyError: 'Errore durante il recupero della gerarchia',
      requestFailed: 'Richiesta non riuscita',
      emailSentSuccess: 'Messaggio e-mail di attivazione inviato con successo.',
      activationEmailError: 'Impossibile inviare e-mail di attivazione.',
      activationEmailError1:
        'Impossibile inviare il messaggio di attivazione. Riprovare in seguito.',
      allOrganisations: 'Tutte le Organizzazioni',
      address: 'Indirizzo',
      hierarchyMetaError: 'Errore durante il recupero dettagli gerarchia',
      nodeMetaError: 'Errore durante il caricamento dettagli nodo',
      contactName: 'Nome contatto',
      downloadTemplate: 'Scarica modello',
      newOrg: 'Nuova organizzazione',
      save: 'salva',
      upload: 'carica',
      uploading: 'Caricamento',
      dropExcel: 'Elimina foglio Excel o',
      browse: 'sfoglia',
      importSettings: 'Impostazioni importazione',
      addNodesSites: 'Aggiungi nuovi nodi/siti',
      updateNodesSites: 'Aggiorna informazioni per i nodi e i siti esistenti',
      disableNodesSites: 'Disabilita nodi/siti che non esistono più',
      disabled: 'Disabilitato',
      new: 'Nuovo',
      updated: 'Aggiornato',
      siteInstallation: 'Siti',
      addOrgSuccess: 'Organizzazione creata con successo!',
      excelUploadError: 'Impossibile salvare excel. Riprovare.',
      saveError: 'Impossibile salvare. Riprovare in seguito.',
      saveBadRequestError:
        'Impossibile salvare. Questo è probabilmente un problema con i dati che stavi cercando di salvare.',
      telephone: 'telefono',
      externalIds: 'ID esterni',
      contactEmail: 'Contatto email',
      longitude: 'Longitudine',
      latitude: 'Latitudine',
      primaryContactName: 'nome contatto principale',
      primaryContactEmail: 'E-mail di contatto principale',
      templateError: 'Errore caricamento template. Riprovare in seguito',
      templateError1: 'Impossibile recuperare template. Riprovare in seguito',
      home: 'Domicilio',
      organisations: 'Organizzazioni',
      users: 'Utenti',
      lightTheme: 'Tema luminoso',
      darkTheme: 'Tema scuro',
      login: 'Accedi',
      logout: 'Logout',
      activateUserAcc: 'Attiva account utente',
      phoneNumber: 'Numero di telefono',
      optional: 'opzionale',
      password: 'Password',
      confirmPassword: 'Conferma password',
      endUser: "Contratto di licenza con l'utente finale",
      iAccept: "Accetto il contratto di Licenza con l'Utente Finale",
      iHereby: 'Confermo di aver letto e accettato',
      eula: 'EULA',
      iRead: "Ho letto l'informativa sulla privacy di Honeywell",
      iUnderstood: 'Sì, ho letto e compreso',
      privacyPolicy: 'Informativa sulla privacy',
      activate: 'attiva',
      activationSuccess: 'Attivazione riuscita',
      newAccAccess:
        "Per accedere al nuovo account, effettuare l'accesso utilizzando il nuovo nome utente. Questo nuovo nome utente è mostrato di seguito:",
      emailSent: "Il nuovo nome utente è stato inviato all'ID e-mail.",
      signin: 'ACCEDI',
      activationError: 'Attivazione non riuscita',
      pleaseTryAgain: 'Riprovare',
      activationExpired: 'Token di attivazione scaduto',
      activationExpiredText:
        'Questo può essere dovuto al fatto che il collegamento via e-mail è scaduto, è già stato usato o non è corretto. Se il problema persiste, richiedere una nuova e-mail di attivazione.',
      contactSupport: "Error. Contattare l'assistenza",
      pwdMatch: 'Le password devono corrispondere',
      required: 'Obbligatorio',
      eligiblePwd:
        'La password deve contenere almeno 1 lettera maiuscola, 1 lettera minuscola, 1 cifra, 1 carattere speciale e almeno 11 caratteri',
      invalidPhoneNumber: 'Numero di telefono non valido',
      invalidName:
        'Il nome non deve superare 255 caratteri senza spazi iniziali o finali',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'fuso orario',
      timeZone: 'fuso orario',
      commissioningStatus: 'stato messa in esercizio',
      countryCode: 'indicativo paese',
      childCount: 'conteggio bambini',
      sheetVersion: 'Versione foglio',
      unknownError: 'Errore sconosciuto. Riprovare in seguito.',
      preview: 'anteprima',
      file: 'File',
      inCompatibleExcel: 'Il file deve essere in formato xlsx.',
      selectOrg: 'Seleziona organizzazione',
      noRecordFound: 'Nessuna registrazione trovata',
      total: 'Totale',
      items: 'Elementi',
      forbidden: 'Vietato',
      noPermissionText:
        'Non si dispone delle autorizzazioni necessarie per accedere a questa pagina',
      accessPermission: 'Accedere a un account con autorizzazioni di accesso',
      technicianExternalAccessPermission: "Accedere all'applicazione mobile",
      redirectToLogin: 'Reindirizzamento alla pagina di login',
      errorUserSettings: 'Errore durante il recupero delle impostazioni utente',
      invalidSystemGuid: 'Sistema Guid non valido',
      languageNotSupported: 'Lingua non supportata',
      subscriptions: 'Sottoscrizioni',
      gatewayManagement: 'Gestione gateway',
      subscriptionNumber: 'Numero abbonamento',
      orderNumber: 'Numero ordine',
      bundle: 'Bundle',
      activatedOn: 'data di attivazione',
      order: 'ordine',
      editSubscription: 'Modifica abbonamento',
      noNodeSelected: 'Nessun nodo selezionato',
      noUserSelected: 'Nessun utente selezionato',
      loadingBundles: 'Caricamento bundle...',
      bundlesError: 'Errore durante il recupero dei pacchetti',
      selectBundle: 'Seleziona bundle',
      addSubscriptionSuccess: 'Iscrizione aggiunta con successo',
      addSubscriptionError:
        "Impossibile aggiungere l'abbonamento. Per favore riprova.",
      subscriptionInputValidationError:
        'può essere un valore alfanumerico con un trattino e non deve superare i 13 caratteri',
      errorUserGlobalPrivileges:
        "Errore durante il recupero dei privilegi globali dell'utente",
      subscriptionAlreadyExist: "L'abbonamento esiste già.",
      invalidSubscription: 'Abbonamento non valido',
      Version: 'Versione',
      systemType: 'Tipo di sistema',
      systemId: 'ID sistema',
      reviewGatewayDetails: 'Rivedi i dettagli del gateway',
      site: 'Sito',
      Organisation: 'Organizzazione',
      gatewayRegistration: 'Registrazione del gateway',
      selectAnOrg: "Seleziona un'organizzazione",
      selectASite: 'Selezionare un sito',
      register: 'Registrazione',
      selectSiteToRegsiter: 'Seleziona il sito per registrare il gateway',
      gatewayRegistrationFailureMsg:
        'Impossibile registrare il gateway con la piattaforma IOT Honeywell Sentience',
      gatewayRegistrationSuccessMsg:
        'Il gateway è stato registrato con successo con la piattaforma IOT Honeywell Sentience',
      siteEmptyMsg:
        "Tutti i siti per l'organizzazione {{- orgName}} sono già registrati",
      forgeOnboarding: "Mappatura dell'organizzazione",
      SiteFetchingFailure: 'Impossibile recuperare i siti da Forge',
      selectAllSitesText:
        'Seleziona tutti i siti di contraffazione da inserire su Remote Building Manager',
      onBoardingFailure: "Impossibile avviare l'onboarding del sito",
      customerID: 'ID cliente',
      enterCustomerID: 'Immettere ID cliente',
      loadingSites: 'Caricamento siti in corso',
      fetchSites: 'RECUPERA SITI',
      subscriptionActivateSuccess:
        'Abbonamento per "{{siteName}}" è attivato correttamente',
      subscriptionActivateError:
        'Impossibile attivare a causa di un problema tecnico, contatta il tuo amministratore',
      activateNow: 'Attivare ora',
      multiSiteSuccess: 'I siti sono stati aggiunti correttamente.',
      onboardSelected: 'Onboarding selezionato',
      sitePartialSuccess:
        "Impossibile caricare alcuni siti a causa di problemi tecnici. Riprovare oppure contattare l'amministratore.",
      confirm: 'Conferma',
      onboardingFailed: 'Onboarding non riuscito',
      failed: 'Non riuscito',
      onboardedSuccessfully: "Sito che ha effettuato l'onboarding",
      notOnboarded: 'Onboarding non eseguito',
      onboarding: 'Onboarding in corso...',
      reOnboard: 'Ri-onboarding',
      selectAll: 'Seleziona tutto',
      siteSuccess: 'Sito aggiunto con succeso.',
      dataloseWarning:
        "Non aggiornare la pagina durante l'onboarding dei siti.",
      addServiceSuccess: 'Servizi aggiunti con successo',
      addServicesText: 'Aggiungi servizi',
      validityText: 'Periodo di validità',
      invalidInputError: 'inserimento non valido',
      subsactivateError: 'Abbonamento già attivato',
      subsnotfoundError: 'Dettagli abbonamento non trovati',
      invalidorderError: "Numero d'ordine non valido",
      bundnotfoundError: 'Dettagli pacchetto non trovati',
      subscribedServices: 'SERVIZI IN ABBONAMENTO',
      subsactivateSuccess: 'Abbonamento creato e attivato con successo',
      subsactivateFailure:
        'Abbonamento creato, ma attivazione non riuscita. Per favore riprova !!',
      subsactivateDiffSite: 'Abbonamento già attivato per un altro sito',
      gatewayAssociation: 'Associazione gateway',
      systemGuid: 'Sistema Guid',
      success: 'Operazione riuscita',
      contactSystemAdministrator: "Contattare l'amministratore di sistema",
      siteName: 'Nome sito',
      location: 'Posizione',
      action: 'Azione',
      addNewSite: 'Aggiungi nuovo sito',
      add: 'Aggiungi',
      sitesAssociated: '{{siteCount}} Siti associati',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Ricerca siti',
      noResultFound: 'Nessun risultato trovato',
      noDataFound: 'Nessun dato trovato',
      unlinkMessage:
        "Per annullare l'associazione di {{siteName}} da {{sku}}, contattare il centro assistenza clienti Honeywell (+01 480-353-3020) o inviare un'e-mail a support@honeywell.com",
      associatedOrderNumber: "Numero d'ordine associato",
      associatedSubscriptionNumber: 'Numero di abbonamento associato',
      helperTextSKU: 'Per modificare il numero di sottoscrizione, contattare',
      helperOrderTextSKU: 'Per modificare il numero di ordine, contattare',
      customerCare: 'Servizio Clienti',
      skuDetails: 'Dettagli SKU',
      manageSites: 'Gestisci siti',
      skuName: 'Nome SKU',
      skuDescription: 'SKU Descrizione',
      licenseUtilization: 'Utilizzo della licenza',
      validTill: 'Valido fino a',
      editSKU: 'Modifica SKU',
      duplicateSiteError: 'Il sito è già stato aggiunto',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: "Errore durante il recupero dell'elenco dei siti",
      siteSuccessMsg: 'Siti Aggiunto correttamente',
      siteFailedMsg: 'Impossibile aggiungere',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Nuovo abbonamento aggiunto',
      licensesOf: 'Licenze di',
      all: 'Tutti',
      orderPlacedBy: 'Ordine effettuato da',
      pendingRenewal: 'In attesa di rinnovo',
      daysRemaining: 'giorni rimanenti',
      renewSubscriptionMessage:
        "Per rinnovare {{skuName}}, contatta il centro assistenza clienti Honeywell (+01 480-353-3020) o invia un'e-mail a support@honeywell.com",
      columnSelection: 'Selezione colonna',
      selectUpTo: 'È possibile selezionare fino a',
      itemsToDisplay: 'elementi da visualizzare nella tabella.',
      subscriptionManagement: 'Gestione abbonamenti',
      activated: 'Attivato',
      warningHeader: 'Annullare comunque?',
      warningMessage: 'Le modifiche non salvate saranno perse',
      renewSubscription: 'Rinnova abbonamento',
      pendingActivation: 'Attivazione in sospeso',
      notAuthorizedError:
        'Non sei autorizzato ad assegnare SKU a questa organizzazione',
      gatewayRegistrationInProgress: '{{gateway}} in corso.',
      gatewayAssociationFailed:
        "Verificare la connettività del gateway e riprovare. In caso di errore, contattare l'amministratore del sistema.",
      gatewayRegistrationFailed:
        "Riprovare. In caso di errore, contattare l'amministratore del sistema.",
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: "Errore nella gestione dell'associazione.",
      association: 'Associazione',
      dataloseWarningForRegistration:
        "La registrazione del gateway è in corso. Potrebbe durare qualche minuto. Non eseguire l'aggiornamento per evitare perdite di dati.",
      dataloseWarningForAssociation:
        "La Associazione del gateway è in corso. Potrebbe durare qualche minuto. Non eseguire l'aggiornamento per evitare perdite di dati.",
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Unità',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Modello aggiunto con successo',
      addTemplateError: 'Impossibile aggiungere il modello.Per favore riprova.',
      updateTemplateSuccess: 'Modello aggiornato correttamente',
      updateTemplateError:
        'Impossibile aggiornare il modello.Per favore riprova.',
      outOfRangeError: 'Il valore deve essere tra {{min}} e {{max}}',
      requiredField: 'Si prega di compilare tutti i campi)',
      templateName: 'Nome modello',
      modelName: 'Nome modello',
      vendorName: 'Nome fornitore',
      uniqueValueError: 'Il valore deve essere unico',
      templateMangement: 'Gestione dei modelli',
      equipmentType: 'Tipo di apparecchiatura',
      selectType: 'Seleziona il tipo',
      listOfTemplate: 'Elenco del modello',
      selectTemplate: 'Seleziona modello',
      ElectricityVoltage: 'Tensione elettrica',
      ElectricityCurrent: 'Corrente di elettricità',
      ElectricPowerFactor: 'Fattore di potenza elettrico',
      ElectricFrequency: 'Frequenza elettrica',
      EnergyReceived: 'Energia ricevuta',
      ActivePower: 'Potenza attiva',
      ActivePowerA: 'Potenza attiva a',
      ActivePowerB: 'Potenza attiva b',
      ActivePowerC: 'Potenza attiva c',
      ReactivePower: 'Potere reattivo',
      ApparentPower: 'Potere apparente',
      PeakDemand: 'Picco di domanda',
      ElectricityCurrentA: 'Corrente elettrica a',
      ElectricityCurrentB: 'Corrente elettrica b',
      ElectricityCurrentC: 'Corrente elettrica c',
      ElectricityVoltageA: 'Tensione elettrica a',
      ElectricityVoltageB: 'Tensione elettrica b',
      ElectricityVoltageC: 'Tensione elettrica c',
      ElectricityConsumption: 'Consumo elettrico',
      loaderWelcomeMessage: 'Benvenuto nel portale Onboarding. Attendere.',
      latitudeAndLongitude: 'Latitudine & Longitudine',
      siteUpdateSuccessMessage: 'Dettagli sito aggiornati correttamente',
      siteUpdateErrorMessage:
        "Errore durante l'aggiornamento dei dettagli sito",
      provisioningFailedMessages:
        'Provisioning del sito non riuscito. Riprovare',
      onboardAllSites: "Effettuare l'onboarding di tutti i siti",
      geoCordinatesErrorMsg: 'Verificare le coordinate',
      tooltipCordinateMessage: 'coordinate devono essere comprese tra',
      emptyValueMessage: 'Valore vuoto non consentito',
      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',
      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',
      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: 'Nome utente alternativo:',
      username: 'Nome utente:',
      errorFetchingUser: "Errore durante il recupero dell'utente",
      errorFetchingRoles: 'Errore durante il recupero dei ruoli',
      gateway: 'GATEWAY',
      associateAndSyncBtn: 'ASSOCIA & SINCRONIZZA',
      cancelBtn: 'ANNULLA',
      guidValidationError: 'Errore di validazione GUID',
      gatewayId: 'ID GATEWAY',
      addNewGateway: 'Aggiungi nuovo gateway',
      successMessage1: 'Associazione del sito, completata',
      successMessage2:
        'Associazione del sito, completata. La sincronizzazione del modello verrà avviata',
      errorMessage:
        'Associazione fallita, la sincronizzazione del modello non verrà avviata',
      importUsers: 'Importa utenti',
      importUsersSubHeading:
        'Aggiungi e gestisci ciò che desideri importare scaricando il modello CSV.',
      dropCsvHere: 'Trascina e rilascia il file qui oppure',
      browsrForFiles: 'Sfoglia i file',
      subHeadingBrowser:
        'Sono accettati solo file CSV e il file non deve superare i 5 MB.',
      subHeadingBrowserTwo: '(è possibile un solo caricamento alla volta)',
      userUploadSuccess: 'Successfully data sent',
      userUploadProcessing:
        'The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.',
      fileNameDisplay: 'File Name :',
      fileName: 'File Name',
      errorNotification:
        'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading: 'Errore',
      slnumber: 'SL NO.',
      errorMessageHeading: 'ERROR MESSAGE',
      endUserAgreement: 'Termini di Honeywell Forge',
      privacyStatement: 'Dichiarazione sulla privacy',
      yourPrivacyChoices: 'Le tue preferenze di privacy',
      cookieNotice: 'Avviso sui cookie',
      dataCentre: 'Centro dati',
      isForgeText: 'Edifici',
      gatewayIdleMessage:
        'Sei stato inattivo per alcuni minuti, aggiorna la pagina per continuare',
      refresh: 'Aggiorna',
      landingLogin: 'Clicca qui',
      loginUserIntegratorRole: 'Utenti BA e-commerce',
      loginUserCustomerRole: 'Tutti gli altri utenti',
      loginWelcomeNote:
        'Benvenuto, scegli il tuo ruolo qui sotto per iniziare.',
      termsAndConditions: 'Termini e condizioni',
      accept: 'Accetta',
      legalPatentInformation: 'Informazioni legali sui brevetti',
      onboardingPortal: 'Portale di onboarding',
      customers: 'Clienti',
      templates: 'Modelli',
      assetModelling: 'Modellizzazione risorse',
      selectCustomer: 'Seleziona cliente',
      integration: 'Integrazione',
      integrationSubtitle:
        'Integrazione senza problemi per approfondimenti sulle prestazioni in tempo reale',
      customer: 'Cliente',
      accessibleCustomersError:
        'Errore durante il recupero dei clienti accessibili',
      workflows: 'Flussi di lavoro (Precedente)',
      apiCredentials: 'Credenziali API',
      integrationsTab: 'Flussi di lavoro',
      noSubscription:
        'Nessun abbonamento attivo. Abbonati per accedere a questa funzione.',
      loading: 'Caricamento...',
      licenseManagement: 'Gestione delle licenze',
      activityLogTitle: 'Registri di attività',
      activityLogSearchPlaceholder: 'Cerca per attività, sito',
      activityLogLastUpdated: 'Ultimo aggiornamento',
      activityLogCreatedOn: 'Creato il',
      activityLogActivity: 'Attività',
      activityLogSite: 'Sito',
      activityLogStatus: 'Stato',
      activityLogCreatedBy: 'Creato da',
      activityLogUpdatedBy: 'Aggiornato da',
      activityLogNameUnavailable: 'Nome non disponibile',
      activityLogUserNamesError:
        'Impossibile caricare i nomi CreatedBy / UpdatedBy',
      activityLogStatusSuccess: 'Operazione riuscita',
      activityLogStatusFailed: 'Non riuscito',
      activityLogStatusInProgress: 'In corso',
      activityLogStatusQueued: 'In coda',
      activityLogStatusPending: 'In sospeso',
      activityLogPaginationInfo:
        '{startItem} - {endItem} di {totalItems} elementi',
      activityLogPageGoTo: 'Vai a pagina',
      activityLogRowPerPage: 'Righe per pagina',
      activityLogRetry: 'Riprova',
      activityLogRetrying: 'Nuovo tentativo in corso...',
      activityLogRetrySuccess: 'Nuovo tentativo attività avviato con successo.',
      activityLogRetryError: 'Nuovo tentativo attività non riuscito. Riprova.',
      activityLogRetryAllSuccess:
        "Tutti i nuovi tentativi dell'attività hanno avuto esito positivo.",
      activityLogRetryAllFailed:
        'Tutti i nuovo tentativi hanno avuto esito negativo. Riprova.',
      activityLogRetryPartialFailed:
        'Alcuni nuovi tentativi attività non sono riusciti. Riprova.',
      activityLogLoading: 'Caricamento dettagli...',
      activityLogFetchError:
        'Non è riuscito a caricare i dati di attività. Per favore, riprova.',
      activityLogModalClose: 'Chiudi',
      activityLogModalTasks: 'Attività',
      activityLogModalCreatedOn: 'Creato il',
      activityLogModalLastUpdatedOn: 'Ultimo aggiornamento il:',
      activityLogModalSupportNote:
        "Descrizione dell'evento di guasto e del codice motivo.",
      activityLogModalSupportReach: 'Per assistenza contattare',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtra per',
      activityLogFilterStatus: 'Stato',
      activityLogFilterActivity: 'Attività',
      activityLogFilterSite: 'Sito',
      activityLogFilterCreatedBy: 'Creato da',
      activityLogFilterApply: 'Applica',
      activityLogFilterReset: 'Ripristina',
      activityLogFilterNoOptions: 'Nessuna opzione disponibile',
      activityLogFilterError:
        'Impossibile caricare le opzioni filtro. Riprova.',
      activityLogCustomizeColumns: 'Personalizza colonne',
      activityLogColumnsReorder: 'Riordinare',
      activityLogColumnsAddRemove: 'Aggiungi/Rimuovi',
      activityLogColumnsReorderDescription:
        "Riposiziona per modificare l'ordine delle colonne nella tabella",
      activityLogColumnsAddRemoveDescription:
        'Selezionare le colonne per visualizzarle nella tabella',
      activityLogDetails: 'Dettagli',
      activityLogSiteState: 'Stato',
      activityLogSiteCity: 'Città',
      workflowTaskCBCustomerCreation: 'Creazione cliente CB',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        "Aggiornamento sullo stato dell'onboarding nel portale partner",
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        "Aggiorna l'ID cliente CB nel portale partner",
      workflowTaskEOMCustomerCreation: 'Creazione cliente EOM',
      workflowTaskOnboardCustomerForAI:
        "Esegui l'onboarding del cliente per l'IA",
      workflowTaskDeleteCustomerInCBPortal: 'Elimina cliente nel portale CB',
      workflowTaskUpdateCustomerInCBPortal:
        'Aggiorna il cliente nel portale CB',
      workflowTaskUpdateCustomerInEOM: 'Aggiorna cliente in EOM',
      workflowTaskUpdateCustomerInAssetModelling: 'Aggiorna il cliente in Modellizzazione risorse',
      workflowTaskTrackScanStatusFileAttachment:
        'Traccia lo stato della scansione del file allegato',
      workflowTaskCBSiteCreation: 'Creazione sito CB',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        "Aggiorna l'ID sito CB nel portale partner",
      workflowTaskEOMSiteCreation: 'Creazione del sito EOM',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        "Aggiorna l'ID del sito EOM nel portale partner",
      workflowTaskSyncExistingUsersCBPortal:
        'Sincronizza gli utenti esistenti con CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Aggiorna lo stato della sincronizzazione utente nel portale partner',
      workflowTaskCalculateEnergySavingsPotential:
        'Calcola potenziale di risparmio energetico',
      workflowTaskDeleteSiteInCBPortal: 'Elimina sito nel portale CB',
      workflowTaskDeleteSiteInEOM: 'Elimina sito in EOM',
      workflowTaskUpdateSiteInCBPortal: 'Aggiorna sito nel portale CB',
      workflowTaskUpdateSiteInEOM: 'Aggiorna sito in EOM',
      workflowTaskUpdateSiteInAssetModelling: 'Aggiorna sito in Modellizzazione risorse',
      workflowTaskUpdateSiteInFindAPI: 'Aggiorna il sito in Find API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        "Sincronizza l'associazione dell'abbonamento al Portale CB",
      workflowTaskEnableBrickOntology: "Abilita l'ontologia Brick",
      workflowTaskOnboardCustomerForgeAPI:
        "Esegui l'onboarding del cliente in ForgeAPI",
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Pubblica lo stato di onboarding ForgeAPI nella Gestione credenziali',
      workflowTaskAddUserInCBPortal: 'Aggiungi utente nel portale CB',
      workflowTaskUpdateUserProvisioningStatus:
        'Aggiorna lo stato del provisioning utente',
      workflowTaskDeleteUserInCBPortal: 'Elimina utente nel portale CB',
      workflowTaskUpdateUserDeletionStatus:
        'Aggiorna lo stato cancellazione utente',
      workflowCustomerCreation: 'Creazione cliente',
      workflowCustomerDelete: 'Eliminazione cliente',
      workflowCustomerUpdate: 'Aggiornamento cliente',
      workflowFileAttachmentsScan: 'Stato scansione file allegati',
      workflowSiteCreation: 'Creazione sito',
      workflowSiteDelete: 'Eliminazione sito',
      workflowSiteUpdate: 'Aggiornamento sito',
      workflowSubscriptionAssociation: 'Associazione sottoscrizione',
      workflowAddUser: 'Aggiungi utente',
      workflowDeleteUser: 'Elimina utente',
      workflowForgeAPIOnboarding: 'Onboarding Forge API',
      workflowAddUserMultiple:
        'Flusso di lavoro per aggiungere utenti multipli',
      workflowDeleteUserMultiple:
        'Flusso di lavoro per eliminare utenti multipli',
      workflowTaskForgeAPIOnboardingStatus: 'Stato onboarding Forge API',
      workflowTaskAddUser: 'Flusso di lavoro per aggiungere un utente',
      activityLogCorrelationId: 'Id correlazione',
      activityLogTaskId: 'ID attività',
      activityLogToastSuccess: 'Operazione riuscita',
      activityLogToastError: 'Errore',
      activityLogIteration: 'Iterazione',
      activityLogFiltersChanged:
        'Nessun dato trovato per i filtri selezionati. Regolare o ripristinare i filtri per vedere i risultati.',
      activityLogResetFilters: 'Ripristina filtri',
      activityLogFieldFirstName: 'Nome',
      activityLogFieldLastName: 'Cognome',
      activityLogFieldSubscriptionName: 'Nome abbonamento',
      activityLogFieldName: 'Nome',
      activityLogFieldCurrency: 'Valuta',
      activityLogFieldZip: 'CAP',
      activityLogFieldArea: 'Area',
      activityLogFieldCity: 'Città',
      activityLogFieldState: 'Stato',
      activityLogFieldCountry: 'Paese',
      activityLogFieldAreaUnit: 'Unità area',
      activityLogFieldLanguage: 'Lingua',
      activityLogFieldLatitude: 'Latitudine',
      activityLogFieldSiteType: 'Tipo di sito',
      activityLogFieldTimezone: 'Fuso orario',
      activityLogFieldLongitude: 'Longitudine',
      activityLogFieldCountryCode: 'Codice paese',
      activityLogFieldSiteId: 'ID Sito',
      activityLogFieldAddressLine1: 'Riga indirizzo 1',
      activityLogFieldAddressLine2: 'Riga indirizzo 2',
      activityLogFieldContactEmail: 'E-mail di contatto'
    }
  }
};
